import { render, staticRenderFns } from "./ShowExperiment.vue?vue&type=template&id=4061c0f2&scoped=true"
import script from "./ShowExperiment.vue?vue&type=script&lang=js"
export * from "./ShowExperiment.vue?vue&type=script&lang=js"
import style0 from "./ShowExperiment.vue?vue&type=style&index=0&id=4061c0f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4061c0f2",
  null
  
)

export default component.exports